import { render } from "./VehicleReplacementTypeForm.vue?vue&type=template&id=5f941cbb"
import script from "./VehicleReplacementTypeForm.vue?vue&type=script&lang=js"
export * from "./VehicleReplacementTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__